import { useNavigate } from "react-router-dom";
import style from './index.module.css';
export default function Four({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   

  return (
    <div className={style.page}>
         <div className={style.fire1} />
        
        <div className={`${style.container} ${style.flexminpage}`}>
            <div className={`${style.header} ${style.topsmin}`}>
                <div className={style.logo} onClick={() => navigate("/")}>I’m-GPT</div>
                <div className={style.enter} onClick={() => navigate("/chat?login")}>
                    <img src='img/enter.png' alt='Войти'/>
                    <p>{login ? user?.email : 'Войти'}</p>
                </div>
            </div>
            <div className={`${style.one} ${style.flexpagescroll}`}>
                <h1>ERROR 404</h1>
                <h2>Данная страница не найдена 🥲</h2>
                <button className={style.btn} onClick={() => navigate("/")}>На главную</button>
                <img src='img/anim.gif' alt="anim" className={style.anim}/>
            </div>
        </div>
    </div>
  );
}
